// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".viewport-drop-target {\r\n  opacity: 1;\r\n  position: relative; /* Locks in Scrollbar */\r\n  -webkit-transition: 0.3s all ease;\r\n  transition: 0.3s all ease;\r\n}\r\n\r\n.viewport-drop-target.hovered {\r\n  opacity: 0.5;\r\n  cursor: copy;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
